import { constants } from '..';

const { SUPPORTED_AUDIO_FILE_TYPES } = constants;

export const getSupportedAudioFormatsLabel = (conjunction: string): string =>
    `${SUPPORTED_AUDIO_FILE_TYPES.slice(
        0,
        SUPPORTED_AUDIO_FILE_TYPES.length - 1,
    ).join(', ')} ${conjunction} ${
        SUPPORTED_AUDIO_FILE_TYPES[SUPPORTED_AUDIO_FILE_TYPES.length - 1]
    }`;
